import React from 'react';

import { Col, Row } from 'react-bootstrap';
import { useIntl } from 'react-intl';

interface IDebugViewProps {
  obj: any;
}

// render a simple object with keys on the left and values on the right
const DebugView = ({ obj }: IDebugViewProps) => {
  const intl = useIntl();
  return (
    <>
      {Object.keys(obj).map((key) => {
        return (
          <Row key={`debug-view-${Math.random()}`}>
            <Col xs={6}>
              <p>{intl.formatMessage({ id: key })}</p>
            </Col>
            <Col xs={6} className="d-flex justify-content-end">
              <p>{obj[key]}</p>
            </Col>
          </Row>
        );
      })}
    </>
  );
};

export default DebugView;
